var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-banner bg-light py-6"},[_c('div',{staticClass:"container text-center"},[_c('h1',{staticClass:"fw-bold mb-2"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.subtitle)?_c('p',{staticClass:"text-muted mb-0"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }